export enum QuestionTypes  {
    FREE_TEXT = "Texto Livre",
    BOOLEAN = "Verdadeiro ou Falso",
    MULTIPLE = "Escolha Múltipla",
    EMAIL = "Email",
    PHONE = "Telemóvel",
    RATING = "Avaliação"
}